import { render, staticRenderFns } from "./TextModal.vue?vue&type=template&id=32a641c4&"
import script from "./TextModal.vue?vue&type=script&lang=js&"
export * from "./TextModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports